import styles from './BottomNav.module.scss'
import { useState, useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { BiMessageAltDots } from 'react-icons/bi'
import { AiFillCalendar, AiFillHome, AiOutlineCalendar, AiOutlineHome } from "react-icons/ai";
import { MdNotificationsActive, MdNotificationsNone } from "react-icons/md";
import { updateToken } from 'actions/user'
import { getMyActivity } from 'actions/activity'
import { getLatestCommunities } from 'actions/community'
import { getLatestEvents } from 'actions/event'
import { setLastHomeRefresh } from 'actions/general'
import { getLatestPosts } from 'actions/post'
import { getMyProfile, getLatestProfiles } from 'actions/profile'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'
import { BiMessageAltDetail } from "react-icons/bi";
import BottomNavButton from './button'
import { IoMdAddCircleOutline } from "react-icons/io";
import { IoMdAddCircle } from "react-icons/io";
import { scrollToTop } from 'helpers/scroll';

interface Props {
}

enum Pages {
  HOME = "/home",
  SEARCH = "/search",
  POSTS = "/postsMain",
  CREATE_EVENT = "/event/create",
  NOTIFICATIONS = "/notifications",
  PROFILE = "/myProfile",
  COMMUNITIES = "/communities",
  FRIENDS = "/friends",
  EVENTS = "/events",
  CALENDAR = "/calendar",
  MESSAGES = "/messages",
}

const BottomNav = (props: Props) => {
  const router = useRouter()
  const pathname = usePathname() || ''
  const dispatch = useAppDispatch()
  const [activeTabs, setActiveTabs] = useState('')
  const uid = useAppSelector((state) => state.userReducer.user?.uid)
  const myProfile = useAppSelector((state) => state.profileReducer.profile)
  const loading = useAppSelector((state) => state.profileReducer.loading)
  const notifications = useAppSelector((state) => state.mainReducer.notifications)

  const lastHomeRefresh = useAppSelector((state) => state.mainReducer?.lastHomeRefresh)
  const goToPage = (page: string) => {
    router.push(page)
  }

  useEffect(() => {
    setActiveTabs(pathname)
  }, [pathname, myProfile])

  const RefreshDisabledPeriod = 1000 * 60 * 0.5

  const refreshToken = async () => {
    await dispatch(updateToken(true))
    if (!myProfile) {
      dispatch(getMyProfile())
      return
    }
  }

  const refreshEvents = async () => {
    await dispatch(updateToken(true))
    if (!myProfile) {
      dispatch(getMyProfile())
      return
    }
    dispatch(getLatestEvents(myProfile?.country, myProfile?.city, "", 30))
  }

  const refreshContent = async (force?: boolean) => {
    await dispatch(updateToken(true))
    if (!myProfile) {
      dispatch(getMyProfile())
      return
    }
    if (!force && new Date().getTime() - lastHomeRefresh < RefreshDisabledPeriod) {
      return;
    }
    dispatch(getLatestCommunities(myProfile?.country, myProfile?.city))
    dispatch(getLatestProfiles(myProfile?.country, myProfile?.city, 20))
    dispatch(getLatestEvents(myProfile?.country, myProfile?.city, "", 30))
    dispatch(getMyActivity())
    dispatch(getLatestPosts("", myProfile?.country, myProfile?.city))
    dispatch(setLastHomeRefresh(new Date().getTime()))
  }

  return (
    <div className={styles.BottomNav}>
      <div className={styles.full_width}>

        <BottomNavButton
          ActiveIcon={AiFillHome}
          InactiveIcon={AiOutlineHome}
          isActive={activeTabs === Pages.HOME || activeTabs === "/"}
          text={"Home"}
          onClickOnActive={() => {
            scrollToTop();
            refreshContent();
          }}
          onClickOnInactive={() => { 
            goToPage(Pages.HOME); 
            refreshContent(); 
          }}
        />

        <BottomNavButton
          ActiveIcon={AiFillCalendar}
          InactiveIcon={AiOutlineCalendar}
          isActive={activeTabs === Pages.CALENDAR}
          text={"Calendar"}
          onClickOnActive={() => goToPage(Pages.CALENDAR)}
          onClickOnInactive={() => { goToPage(Pages.CALENDAR); refreshEvents(); }}
        />

        <BottomNavButton
          ActiveIcon={IoMdAddCircle}
          InactiveIcon={IoMdAddCircleOutline}
          isActive={activeTabs === Pages.CREATE_EVENT}
          text={"Create Event"}
          onClickOnActive={() => goToPage(Pages.CREATE_EVENT)}
          onClickOnInactive={() => { goToPage(Pages.CREATE_EVENT); refreshToken(); }}
        />
        {/* <BottomNavButton
          ActiveIcon={IoSearch}
          InactiveIcon={IoSearchOutline}
          isActive={activeTabs === Pages.SEARCH}
          text={"Search"}
          onClickOnActive={() => goToPage(Pages.SEARCH)}
          onClickOnInactive={() => { goToPage(Pages.SEARCH) }}
        /> */}


        <BottomNavButton
          ActiveIcon={BiMessageAltDots}
          InactiveIcon={BiMessageAltDetail}
          isActive={activeTabs === Pages.MESSAGES}
          text={"Messages"}
          onClickOnActive={() => goToPage(Pages.MESSAGES)}
          onClickOnInactive={() => { goToPage(Pages.MESSAGES); refreshToken(); }}
        />

        <BottomNavButton
          ActiveIcon={MdNotificationsActive}
          InactiveIcon={MdNotificationsNone}
          // ExtraElement={
          //   notifications?.length > 0 ?
          //     <div className={styles.notification_white} onClick={() => goToPage(Pages.NOTIFICATIONS)}>{notifications.length}</div>
          //     : undefined
          // }
          isActive={activeTabs === Pages.NOTIFICATIONS}
          text={"Notifications"}
          onClickOnActive={() => goToPage(Pages.NOTIFICATIONS)}
          onClickOnInactive={() => { goToPage(Pages.NOTIFICATIONS); refreshToken(); }}
        />


      </div>
    </div >
  )
}

export default BottomNav
